var _a;
var DEFAULT_CONSOLE_CAPTURE_PREFIX = "[Ascent Debugger]";
/**
 * The prefix used to identify Ascent Debugger log lines in the browser console.
 * Can be overridden via the `CONSOLE_CAPTURE_PREFIX` environment variable (Node.js only).
 * Browser bundles always use the default value since `process.env` is not available at runtime.
 */
export var CONSOLE_CAPTURE_PREFIX = (typeof process !== "undefined" && ((_a = process.env) === null || _a === void 0 ? void 0 : _a.CONSOLE_CAPTURE_PREFIX)) ||
    DEFAULT_CONSOLE_CAPTURE_PREFIX;
// Attach a global debug assertions array (safe for prod, empty by default)
if (typeof window !== "undefined") {
    var existing = window
        .__ASCENT_DEBUG_ASSERTIONS;
    window.__ASCENT_DEBUG_ASSERTIONS = existing !== null && existing !== void 0 ? existing : [];
}
export var DEBUG_ASSERTIONS = typeof window !== "undefined"
    ? window
        .__ASCENT_DEBUG_ASSERTIONS
    : [];
